/**
 * Gift Reggie - Velour Theme Integration
 * Handles: registry button visibility, cart warnings, discount codes
 */

(function () {
  'use strict';

  var registry_id = 0;
  var giftreggie_lh_visible = window.__giftreggie_lh_visible || false;
  var is_customer_logged = window.__is_customer_logged || false;

  /**
   * Check if cart contains a Gift Registry item
   */
  function hasGiftReggieItemOnCart(cart) {
    if (!cart || !cart.items || cart.items.length === 0) return false;

    return cart.items.some(function (item) {
      return item.properties && typeof item.properties['Lista de Presentes #'] !== 'undefined';
    });
  }

  /**
   * Show/hide cart warning and apply/remove discount for registry items
   */
  function checkGiftReggieCartItem(cart) {
    var hasListItem = hasGiftReggieItemOnCart(cart);
    var warningDiv = document.querySelector('.wt-cart__gift-warning');
    var discountToApplyInput = document.querySelector('#CartDrawer-Form input[name="discount"]');
    var discountToApply = 'LISTA-FRETE-GRATIS';

    if (discountToApplyInput) {
      discountToApplyInput.value = hasListItem ? discountToApply : '';
    }

    if (warningDiv) {
      if (hasListItem) {
        warningDiv.classList.add('wt-cart__gift-warning--visible');
      } else {
        warningDiv.classList.remove('wt-cart__gift-warning--visible');
      }
    }
  }

  /**
   * Show gift reggie buttons on product cards in collection pages
   */
  function showGRListButtons() {
    document.querySelectorAll('product-add-gift-reggie .gift-reggie-card-btn').forEach(function (btn) {
      btn.style.display = 'block';
      btn.addEventListener('click', addToGiftReggieList);
    });
  }

  /**
   * Show gift reggie buttons on product detail page
   */
  function showGRProductButton() {
    document.querySelectorAll('.gift-reggie-buttons').forEach(function (el) {
      el.style.cssText = 'display:flex !important';
    });
  }

  /**
   * Add item to gift registry from collection card
   */
  function addToGiftReggieList(e) {
    var btn = e.currentTarget;
    var variantId = btn.value;
    var productId = btn.dataset.productId;

    if (!variantId || !registry_id) return;

    var originalText = btn.textContent;
    btn.textContent = '...';
    btn.disabled = true;

    if (window.gift_reggie && window.gift_reggie.session) {
      window.gift_reggie.session.addRegistryProducts(registry_id, productId, variantId, 1, {}).done(function () {
        btn.textContent = 'Adicionado!';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      }).fail(function () {
        btn.textContent = originalText;
        btn.disabled = false;
        alert('Erro ao adicionar produto a lista.');
      });
    } else {
      window.location = '/apps/giftregistry/manage?id=' + variantId;
    }
  }

  /**
   * Check conditions and show/hide gift reggie buttons
   */
  function checkGRButtons() {
    var giftreggie_registry_session = window.localStorage.getItem('giftreggie-logged');

    if (giftreggie_registry_session && giftreggie_lh_visible && is_customer_logged) {
      try {
        registry_id = JSON.parse(giftreggie_registry_session).registry_id;
      } catch (e) {
        registry_id = 0;
      }
    }

    if (registry_id > 0) {
      showGRProductButton();

      var hasRelated = document.querySelector('.wt-product-recommendations, [data-product-recommendations]');

      if (!hasRelated) {
        showGRListButtons();
      } else {
        setTimeout(function () {
          showGRListButtons();
        }, 700);
      }
    }
  }

  /**
   * Fetch cart and check for registry items (for cart drawer warning)
   */
  function initCartCheck() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        checkGiftReggieCartItem(cart);
      })
      .catch(function () {});
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', function () {
    checkGRButtons();
    initCartCheck();
  });

  // Re-check on cart updates (listen to Velour's pub/sub if available)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      initCartCheck();
    });
  }

  // Expose for external use
  window.__giftreggie = {
    checkGRButtons: checkGRButtons,
    checkGiftReggieCartItem: checkGiftReggieCartItem,
    hasGiftReggieItemOnCart: hasGiftReggieItemOnCart
  };
})();
